import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';

type Props = {
  register: UseFormRegister<NotificationFormFields>;
  error: FieldError | undefined;
};

/**
 * お知らせタイトルのフォームです。
 * Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const TitleForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>タイトル</FormLabel>
    <Input
      id="title"
      type="text"
      {...register('title', {
        required: '必須項目です。',
        maxLength: {
          value: 100,
          message: 'タイトルは 100 文字以内にする必要があります。',
        },
      })}
    />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
